import React from "react";
import Image from "next/image";
import { minimizeText } from "@shared/functions";

interface CardAvatarProps {
  imgUrl: string;
  userName: string;
}

export const PostAvatar = ({ imgUrl, userName }: CardAvatarProps) => {
  return (
    <div
      className={
        "px-1 flex items-center rounded-full cursor-pointer h-120 w-fit bg-gradient-to-t from-black opacity-90 mb-1"
      }
    >
      <div
        className={
          "w-6 h-6 ml-[-1px] mt-1 mb-1 mr-1 overflow-hidden border rounded-full border-primary-color ring ring-primary-color"
        }
        style={{ boxShadow: "1px 1px 30px #00F3CD" }}
      >
        <Image
          src={imgUrl}
          className={"object-cover object-center w-full h-full rounded-full"}
          width={50}
          height={50}
          alt={""}
        />
      </div>
      <h3 className={" text-[9px] font-normal text-white"}>
        {minimizeText(userName, 16)}
      </h3>
    </div>
  );
};
